interface NavigationItem {
  label: string
  icon?: string
  path: string
  disabled?: boolean
  inertia: boolean
  children?: NavigationItem[]
  notifications?: number
  iconWarning?: string | null
  mobile?: boolean
  desktop?: boolean
  exact?: boolean
}

type UserType = 'manager' | 'agency' | 'pro' | 'client'

const homeItem: NavigationItem = {
  label: 'Dashboard',
  path: '/',
  inertia: true,
}

const menuItems: Record<UserType, NavigationItem[]> = {
  manager: [
    {
      label: 'Carte',
      icon: 'LocationMarkerIcon',
      path: '/statistics/map',
      disabled: false,
      inertia: true,
    },
    {
      label: 'Tâches',
      icon: 'ClipboardListIcon',
      path: '/tasks/assigned/',
      disabled: false,
      inertia: true,
    },
    {
      label: 'Prospects',
      icon: 'FireIcon',
      disabled: false,
      path: '/projects/prospects/owned/',
      children: [],
      notifications: 0,
      iconWarning: null,
      mobile: true,
      desktop: true,
      exact: true,
      inertia: true,
    },
    {
      label: 'Consultations',
      icon: 'UserGroupIcon',
      disabled: false,
      path: '/consultations/owned/',
      children: [],
      notifications: 0,
      iconWarning: null,
      mobile: true,
      desktop: true,
      exact: true,
      inertia: true,
    },
    {
      label: "Apports d'affaires",
      icon: 'LinkIcon',
      disabled: false,
      path: '/partnerships/owned/',
      children: [],
      notifications: 0,
      iconWarning: null,
      mobile: true,
      desktop: true,
      exact: true,
      inertia: true,
    },
    {
      label: 'Études',
      icon: 'BeakerIcon',
      disabled: false,
      path: '/studies/owned/',
      children: [],
      notifications: 0,
      iconWarning: null,
      mobile: true,
      desktop: true,
      exact: true,
      inertia: true,
    },
    {
      label: 'Pros',
      icon: 'OfficeBuildingIcon',
      disabled: false,
      path: '/pros',
      children: [],
      notifications: 0,
      mobile: true,
      desktop: true,
      exact: true,
      inertia: true,
    },
  ],
  agency: [
    {
      label: 'Consultations',
      icon: 'UserGroupIcon',
      disabled: false,
      path: '/my-consultations/',
      children: [],
      notifications: 0,
      iconWarning: null,
      mobile: true,
      desktop: true,
      exact: true,
      inertia: true,
    },
    {
      label: "Apports d'affaires",
      icon: 'BriefcaseIcon',
      disabled: false,
      path: '/my-partnerships/',
      children: [],
      notifications: 0,
      iconWarning: null,
      mobile: true,
      desktop: true,
      exact: true,
      inertia: true,
    },
    {
      label: 'Études',
      icon: 'BeakerIcon',
      disabled: false,
      path: '/my-studies/',
      children: [],
      notifications: 0,
      iconWarning: null,
      mobile: true,
      desktop: true,
      exact: true,
      inertia: true,
    },
  ],
  pro: [
    {
      label: "Apports d'affaires",
      icon: 'BriefcaseIcon',
      disabled: false,
      path: '/my-partnerships/',
      children: [],
      notifications: 0,
      iconWarning: null,
      mobile: true,
      desktop: true,
      exact: true,
      inertia: true,
    },
    {
      label: 'Études',
      icon: 'BeakerIcon',
      disabled: false,
      path: '/my-studies/',
      children: [],
      notifications: 0,
      iconWarning: null,
      mobile: true,
      desktop: true,
      exact: true,
      inertia: true,
    },
  ],
  client: [],
}

const secondaryItems: Record<UserType, NavigationItem[]> = {
  manager: [
    {
      label: 'Attributions',
      icon: 'GlobeIcon',
      path: '/administration/attributions',
      inertia: true,
    },
    {
      label: 'Statistiques',
      icon: 'ChartBarIcon',
      path: '/statistics/global',
      inertia: true,
    },
    {
      label: 'Équipe',
      icon: 'UserGroupIcon',
      path: '/managers',
      inertia: true,
    },
    {
      label: 'Paramètres',
      icon: 'AdjustmentsIcon',
      path: '/params/',
      inertia: true,
    },
    {
      label: 'Admin (django)',
      icon: 'CogIcon',
      path: '/chantier44charrettes56/',
      inertia: false,
    },
  ],
  agency: [
    {
      label: 'Profil public',
      icon: 'UserIcon',
      path: '/profile',
      inertia: true,
    },
    {
      label: 'Mon équipe',
      icon: 'UserGroupIcon',
      path: '/team',
      inertia: true,
    },
    {
      label: 'Références',
      icon: 'BriefcaseIcon',
      path: '/references/',
      inertia: true,
    },
    {
      label: 'Conformité',
      icon: 'UserGroupIcon',
      path: '/documents',
      inertia: true,
    },
    {
      label: 'Recommandations',
      icon: 'ThumbUpIcon',
      path: '/recommendations',
      inertia: true,
    },
  ],
  client: [],
  pro: [],
}

const accountItems: Record<UserType, NavigationItem[]> = {
  manager: [
    {
      label: 'Mon compte',
      icon: 'UserIcon',
      path: '/account',
      inertia: true,
    },
    {
      label: 'Notifications',
      icon: 'BellIcon',
      path: '/notifications',
      inertia: true,
    },
  ],
  agency: [
    {
      label: 'Mon compte',
      icon: 'UserIcon',
      path: '/account',
      inertia: true,
    },
    {
      label: 'Facturation',
      icon: 'CreditCardIcon',
      path: '/invoicing/',
      inertia: true,
    },
    {
      label: 'Notifications',
      icon: 'BellIcon',
      path: '/notifications',
      inertia: true,
    },
  ],
  pro: [
    {
      label: 'Mon compte',
      icon: 'UserIcon',
      path: '/account',
      inertia: true,
    },
    {
      label: 'Facturation',
      icon: 'CreditCardIcon',
      path: '/invoicing/',
      inertia: true,
    },
    {
      label: 'Notifications',
      icon: 'BellIcon',
      path: '/notifications',
      inertia: true,
    },
  ],
  client: [
    {
      label: 'Mon compte',
      icon: 'UserIcon',
      path: '/account',
      inertia: true,
    },
    {
      label: 'Facturation',
      icon: 'CreditCardIcon',
      path: '/invoicing/',
      inertia: true,
    },
    {
      label: 'Notifications',
      icon: 'BellIcon',
      path: '/notifications',
      inertia: true,
    },
  ],
}

const getMenuItems = (userType: UserType): NavigationItem[] => {
  return menuItems[userType]
}

const getAccountItems = (userType: UserType): NavigationItem[] => {
  return accountItems[userType]
}

const getSecondaryItems = (userType: UserType): NavigationItem[] => {
  return secondaryItems[userType]
}

export { getAccountItems, getMenuItems, getSecondaryItems, homeItem }
export type { NavigationItem, UserType }
